import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useToast } from 'use-toast-mui';

import AnimationPage from '../../../pages/AnimationPage';
import PrivateLessonList from './PrivateLessonList';
import { getBranchTime } from '../../../api/center-branch';
import { errorMessages, toTop } from '../../../utils/methods';

const PrivateLesson = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const { user } = useSelector(state => state.user);

  const [periodTimes, setPeriodTimes] = useState(null);

  // 지점 시간 설정 조회
  const getBranchPeriodTime = async () => {
    if (!user.branch?.branchId) return;

    try {
      const branchTime = await getBranchTime(user.branch.branchId, user.token);
      setPeriodTimes({
        startTime: branchTime.startTime,
        endTime: branchTime.endTime,
      });
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  useEffect(() => {
    toTop();
  }, []);

  useEffect(() => {
    if (user.branch?.branchId) {
      getBranchPeriodTime();
    }
  }, [user.branch?.branchId]);

  if (!user.branch?.branchId) {
    return t('Please select a point');
  }

  return (
    <AnimationPage>
      <Box
        component={Paper}
        elevation={0}
        sx={{
          borderRadius: '10px',
          width: '100%',
          position: 'relative',
        }}>
        <PrivateLessonList courseClassType="PRIVATE_LESSON" periodTimes={periodTimes} onPeriodTimesSaved={getBranchPeriodTime} />
      </Box>
    </AnimationPage>
  );
};

export default PrivateLesson;
